export const homepage = {
  // Hero Section
  heroTitle: 'Find Your Perfect Rental Car',
  heroSubtitle: 'Unlock endless possibilities with our comprehensive car rental platform. Connect with thousands of verified agencies across the globe, enjoy seamless booking experiences, competitive pricing, and premium vehicles that make every journey memorable and stress-free.',
  searchCars: 'Search Cars',
  findBookRental: 'Find, book, and rental car in',
  easySteps: 'Easy steps.',
  getCarWherever: 'Get a car wherever and whenever you need it with professional service and competitive prices.',
  
  // Search Form
  location: 'Location',
  pickupDate: 'Pickup Date',
  returnDate: 'Return Date',
  
  // Steps Section
  rentWithSteps: 'Rent with following 3 working steps',
  chooseLocation: 'Choose location',
  chooseLocationDesc: 'Choose your location and find your best car',
  pickupDateDesc: 'Select your pick up date and time to book your car',
  bookYourCar: 'Book your car',
  bookYourCarDesc: 'Book your car and we will deliver it directly to you',
  
  // Features
  whyChooseKiraCar: 'Why Choose KiraCar?',
  whyChooseSubtitle: 'Experience the best car rental service with our verified agencies and exceptional customer support.',
  verifiedAgencies: 'Verified Agencies',
  verifiedAgenciesDesc: 'All rental agencies are thoroughly verified for your safety and peace of mind.',
  support247: '24/7 Support',
  support247Desc: 'Round-the-clock customer support to assist you whenever you need help.',
  bestPrices: 'Best Prices',
  bestPricesDesc: 'Compare prices from multiple agencies to find the best deals on car rentals.',
  trustedReviews: 'Trusted Reviews',
  trustedReviewsDesc: 'Read genuine reviews from verified customers to make informed decisions.',
  
  // Sections
  featuredCars: 'Featured Cars',
  featuredCarsDesc: 'Discover our most popular rental cars from trusted agencies.',
  trustedAgencies: 'Trusted Agencies',
  trustedAgenciesDesc: 'Partner with the most reliable car rental agencies worldwide.',
  viewAllCars: 'View All Cars',
  
  // CTA
  readyToStart: 'Ready to Start Your Journey?',
  readyToStartDesc: 'Join thousands of satisfied customers and find your perfect rental car today.',
  browseCars: 'Browse Cars',
  joinAsAgency: 'Join as Agency',
  
  // Footer
  quickLinks: 'Quick Links',
  forAgencies: 'For Agencies',
  agencyHelp: 'Agency Help',
  termsOfService: 'Terms of Service',
  privacyPolicy: 'Privacy Policy',
  allRightsReserved: 'All rights reserved',
}; 